import React from 'react';
import { Button, Tooltip } from 'antd';
import styles from './advanced-filter-view.module.sass';
import cx from 'classnames';
import { FilterFilled } from '@ant-design/icons';
import mixpanel from 'mixpanel-browser';

export function AdvancedFilterButton({
  filterSidebarOpen,
  filterProfileApplied,
  toggleFilterSidebar,
}) {
  return (
    <Tooltip placement="right" title="Advanced filtering options">
      <Button
        role={'button1'}
        className={cx(styles.advancedFilterButton, {
          [styles.inFocus]: filterSidebarOpen || !!filterProfileApplied,
        })}
        onClick={() => {
          mixpanel.track('Filter Open');
          toggleFilterSidebar();
        }}
        icon={<FilterFilled />}
      >
        Advanced Filter
      </Button>
    </Tooltip>
  );
}
